import './style.css';
import { installHttpDebugInterceptor } from './utils/httpDebugLog';
import { App } from './app/App';

installHttpDebugInterceptor();

const app = new App(document.querySelector<HTMLElement>('#app')!);
app.start();
